var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHolidays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2168_8235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.2 3.8H32.3V0H28.5V3.8H9.5V0H5.7V3.8H3.8C1.71 3.8 0 5.51 0 7.6V38C0 40.09 1.71 41.8 3.8 41.8H34.2C36.29 41.8 38 40.09 38 38V7.6C38 5.51 36.29 3.8 34.2 3.8ZM34.2 38H3.8V13.3H34.2V38Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2168_8235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 41.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidays);
export default __webpack_public_path__ + "static/media/Holidays.5c1427fe76021549629eeb662fa36b6d.svg";
export { ForwardRef as ReactComponent };